export const constants = {
  typeClientSelected: 1,

  typeBedroomSelected: 1,
  serviceHotelSelected: 1,
  packageTourPriceSelected: 1,

  package_typeprice_tour: 1,
  package_typeprice_tourandhotel: 2,
  package_typeprice_multicity: 3,

  paymentmethod_init_id: 1,
  pre_search_string: '%%',

  // MODULES BOOKING
  module_booking: 1,
  module_bookinghotel: 2,
  module_bookingflight: 3,

  PRODUCT: {
    TYPEPRICE: [
      { description: 'Precio general', id: 1, key: 'price_general' },
      { description: 'Precio por unidad de medida', id: 2, key: 'price_unit' },
      { description: 'Precio por variantes', id: 3, key: 'price_variant' },
      { description: 'Precio variable', id: 4 }
    ],
    TYPEPRODUCT: [
      { description: 'BIENES', key: 'good', id: 1 },
      { description: 'SERVICIOS', key: 'service', id: 2 }
    ],

    SEGMENTPRICES: [
      { description: 'Precio Venta', id: 1, key: 'price_sale' },
      { description: 'Precio Mímino', id: 2, key: 'price_min' },
      { description: 'Precio Crédito', id: 3, key: 'price_credit' },
      { description: 'Precio Mayorista', id: 4, key: 'price_wholesaler' }
    ]
  },

  CLIENT: {
    TYPE: [
      { description: 'Natural', id: 2 },
      { description: 'Jurídico', id: 1 }
    ],
    TYPE_DOCUMENT: {
      DNI: { max_length: 8, description: 'DNI', id: 1, key: 'document_dni' },
      RUC: { max_length: 11, description: 'RUC', id: 2, key: 'document_ruc' }
    },
    DEFAULT: {
      id: 1,
      fullname: 'CLIENTE VARIOS',
      typeDocument: 'DNI',
      document: '11111111',
      address: '-'
    },
    AGE_GROUP: [
      { description: 'ADULTO', id: 1, key: 'A' },
      { description: 'NIÑO', id: 2, key: 'N' },
      { description: 'INFANTE', id: 3, key: 'I' }
    ],
    COUNTRY: [
      { nombrepais: 'PERÚ', id: 168 }
    ],
  },

  USER: {
    TYPES: [
      { description: 'Clientes', id: 1 },
      { description: 'Proveedores', id: 2 },
      { description: 'Empleados', id: 3 },
      { description: 'Guias de viaje', id: 4 },
      { description: 'Transportes', id: 5 },
      { description: 'Agencias', id: 6 },
      { description: 'Hoteles', id: 7 },
      { description: 'Colab. externos', id: 8 }
    ],
    STATUS: [
      { description: 'Activos', id: 1, status: true },
      { description: 'De baja', id: 2, status: false }
    ]
  },

  SALE: {
    VOUCHER: [
      { description: 'BOLETA ELECTRÓNICA', id: 1, key: 'BOLETA_ELECTRONICA' },
      { description: 'FACTURA ELECTRÓNICA', id: 2, key: 'FACTURA_ELECTRONICA' },
      { description: 'NOTA CREDITO', id: 3, key: 'NOTA_CREDITO' },
      { description: 'NOTA DEBITO', id: 4, key: 'NOTA_DEBITO' },
      { description: 'NOTA PEDIDO', id: 8, key: 'NOTA_PEDIDO' },
      { description: 'RECIBO INGRESO', id: 9, key: 'RECIBO_INGRESO' },
      { description: 'RECIBO EGRESO', id: 10, key: 'RECIBO_EGRESO' },
      { description: 'PROFORMA', id: 7, key: 'PROFORMA' }
    ],
    TRANSACTIONS: [
      { description: 'CONTADO', id: 1, key: 'transaction_cash' },
      { description: 'CRÉDITO', id: 2, key: 'transaction_credit' },
      {
        description: 'CRÉDITO CON CUOTAS',
        id: 3,
        key: 'transaction_credit_parts'
      }
    ]
  },

  TOURISM: {
    SHIFT_TOURS: [
      { description: 'Full day', id: 1 },
      { description: 'Mañana', id: 2 },
      { description: 'Tarde', id: 3 },
      { description: 'Noche', id: 4 }
    ],
    VEHICLE_TOURS: [
      { description: 'Compartido', class: 'info', id: 1 },
      { description: 'Privado', class: 'orange', id: 2 }
      // {description: "Todos", class: "orange", id: null},
    ],

    ARRIVAL_BOOKING: [
      { description: 'Sin asignar', id: null },
      { description: 'Aeropuerto', id: 1 },
      { description: 'Terminal terrestre', id: 2 },
      { description: 'Otros', id: 3 },
      { description: 'A Cuenta propia', id: 4 }
    ]
  },

  HOTEL: {
    TRANSFERS: [
      { description: 'RECOJO', class: 'success', icon:'fas fa-plane-arrival', id: 1 },
      { description: 'TRASLADO', class: 'danger', icon:'fas fa-plane-departure', id: 2 }
      // {description: "Todos", class: "orange", id: null},
    ],
    TYPE_RATES: [
      { description: 'T.Pública', id: 1 , value:"public"},
      { description: 'T.Corporativa', id: 2, value:"corporate"},
      { description: 'CONVENIOS EMPRESA', id: 3, value:"agreement"},
      // {description: "Todos", class: "orange", id: null},
    ],
  },

  REPORT: {
    VIEW_SCHEDULE: [
      { description: 'Resumen anual', id: 1 },
      { description: 'Resumen mensual', id: 2 }
    ]
  },

  COMPANY: {
    CATEGORY: {
      GENERAL_SERVICES: {description: 'Servicios generales', id: 7},
    },
  },
};
